import React, { useEffect } from "react";
import {
  RestlessTable,
  RestlessButtonFormatter,
} from "../../../_metronic/layout/components/Table";
import * as actions from "../../../redux/actions/hashtags";
import { useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route } from "react-router-dom";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import { Alert } from "react-bootstrap";

export default function RestlessHashtagsPage({ history }) {
  const dispatch = useDispatch();

  const {
    hashtagsList,
    listLoading,
    error,
    banLoading,
    hashtagBanned,
  } = useSelector((state) => ({
    hashtagsList: state.hashtags.hashtagsList,
    listLoading: state.hashtags.listLoading,
    error: state.hashtags.error,
    banLoading: state.hashtags.banLoading,
    hashtagBanned: state.hashtags.hashtagBanned,
  }));

  useEffect(() => {
    dispatch(actions.fetchHashtags());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Array of buttons, atributes = onClickFunction, text, icon
  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return hashtagsUIEvents.openHashtagsDetailsPage(row);
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        return hashtagsUIEvents.openModerateHashtagsDialog(row);
      },
      icon: (
        <SVG title="Moderate" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Moderate"
    },
  ];

  const columns = [
    {
      dataField: "hashtag",
      text: "Hashtag",
      sort: true,
      formatter: (cellContent) => <strong>{cellContent}</strong>,
    },
    {
      dataField: "banned",
      text: "Banned",
      sort: true,
      formatter: (cellContent) => <div>{cellContent ? "Yes" : "No"}</div>,
    },
    {
      dataField: "counter",
      text: "Times used",
      sort: true,
      formatter: (cellContent) => <div>{cellContent || "0"}</div>,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr },
    },
  ];

  const hashtagsUIEvents = {
    openHashtagsDetailsPage: (row) => {
      history.push({
        pathname: `/hashtags/${encodeURIComponent(row.hashtag)}/details`,
        state: {
          row: row,
          prevPath: `/hashtag/${encodeURIComponent(row.hashtag)}/details`,
        },
      });
    },
    openModerateHashtagsDialog: (row) => {
      history.push({
        pathname: `/hashtags/${row.id}/moderate`,
        state: { row: row },
      });
    },
  };

  const onSubmit = (values, row) => {
    dispatch(actions.banHashtag(row));

    history.push("/hashtags");
  };

  const renderHashtagModerationStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible>
        {`The hashtag ${hashtagBanned.hashtag} has been banned succesfully`}
      </Alert>
    );
  };

  const renderHashtagModerationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible>
        An error has occurred
      </Alert>
    );
  };

  return (
    <>
      {listLoading || banLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error && hashtagBanned && renderHashtagModerationStatus()}
          {error && !hashtagBanned && renderHashtagModerationError()}
          <Route path="/hashtags/:id/moderate">
            {({ history, match }) => (
              <RestlessModerationModal
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                onSubmit={onSubmit}
                onHide={() => {
                  history.push("/hashtags");
                }}
                entityType="Hashtag"
              />
            )}
          </Route>
          <RestlessTable data={hashtagsList} columns={columns} withPagination />
        </>
      )}
    </>
  );
}
